import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import { newFormatPrice } from '../../../../services/utilityFunctions';
import UserCard from './UserCard';
import CrossIcon from '../../../../commonComponents/icons/CrossIcon';
import InfoIcon from '../../../../commonComponents/icons/InfoIcon';
import CheckIcon from '../../../../commonComponents/icons/CheckIcon';

function GlobalSummary(props) {
  const { t, data, bestEliteBranch } = props;

  const {
    user,
    isActive,
    margin,
    successBonus,
    fastStartBonus,
    vatThreshold,
  } = data;

  const totalForecastCurrentMonth =
    bestEliteBranch + margin + successBonus + fastStartBonus;

  return (
    <div className="flex-row" id="laborigin-summary">
      <div className="grid-item">
        {user && <UserCard user={user} directSellingActive />}
      </div>
      <div className="grid-item" style={{ flex: 1 }}>
        <div className="card card-laborigin-commission">
          <div className="total-commission">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 3,
                marginBottom: 30,
              }}
            >
              {isActive ? <CheckIcon color="#3FBC5F" /> : <CrossIcon />}
              {t('report.arcova.isActive')}
            </div>
            <div className="title">
              {t('report.laborigin.summary.totalCommissions')}
            </div>
            <div className="price">
              {newFormatPrice(
                totalForecastCurrentMonth,
                false,
                user?.userPrice?.code,
              )}
            </div>
            <div>{t('teamStructure.card.level.forecast')}</div>
          </div>
        </div>
      </div>
      <div className="grid-item" style={{ flex: 1 }}>
        <div className="card your-level">
          <div className="card-body">
            <div className="title">{t('report.laborigin.summary.margin')}</div>
            <div className="amount">
              {newFormatPrice(margin, false, user?.userPrice?.code)}
            </div>
          </div>
        </div>
      </div>
      <div className="grid-item" style={{ flex: 1 }}>
        <div className="card your-level">
          <div className="card-body-double">
            <div className="card-body">
              <div className="title">
                {t('report.laborigin.summary.successBonus')}
              </div>
              <div className="amount">
                {newFormatPrice(successBonus, false, user?.userPrice?.code)}
              </div>
            </div>
            <div className="divider" />
            <div className="card-body">
              <div className="title">
                {t('report.laborigin.summary.fastStart')}
              </div>
              <div className="amount">
                {newFormatPrice(fastStartBonus, false, user?.userPrice?.code)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid-item" style={{ flex: 1 }}>
        <div className="card your-level">
          <div className="card-body">
            <div className="title">
              {t('report.laborigin.summary.vatThreshold')}
              <span className="icon">
                <InfoIcon
                  width={20}
                  height={20}
                  color="#fff"
                  tooltip={t('report.laborigin.tooltip.vat')}
                />
              </span>
            </div>
            <div className="amount">
              {newFormatPrice(
                vatThreshold + totalForecastCurrentMonth,
                false,
                user?.userPrice?.code,
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

GlobalSummary.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    user: PropTypes.shape(UserProp.propType).isRequired,
    userId: PropTypes.string,
    // 1st block, Levels
    level: PropTypes.number,
    forecastLevel: PropTypes.number,
    lastMonthLevel: PropTypes.number,
    // 2nd block, commissions + active
    isActive: PropTypes.bool,
    totalCommissions: PropTypes.number,
    // 3rd block
    margin: PropTypes.number,
    // 4th block
    successBonus: PropTypes.number,
    fastStartBonus: PropTypes.number,
    // 5th block
    vatThreshold: PropTypes.number,
  }).isRequired,
  bestEliteBranch: PropTypes.number.isRequired,
};

export default translate(GlobalSummary);
